
// import React, { useEffect, useState } from 'react'
// import '../styleCss/processStyle.css'
// import { Link } from 'react-router-dom';
// import '../styleCss/a.css'
// import { HashLink } from 'react-router-hash-link';

// import { SiTradingview } from 'react-icons/si';
// import { FaCode } from 'react-icons/fa';
// import { LuImage } from "react-icons/lu";
// import SEO from '../SEO';
// import TypingText from './TypingText';
// import Header from './Header';
// import Footer from './Footer';

// const ProcessOverview = () => {






//   const [activeTab, setActiveTab] = useState("ui");

//   const tabs = [
//     { id: "ui", label: "EXECUTE BY UI", icon: <LuImage /> },
//     // { id: "tradingview", label: "EXECUTE BY TRADINGVIEW", icon: <SiTradingview></SiTradingview> },
//     // { id: "code", label: "EXECUTE BY MANUAL CODE", icon: <FaCode></FaCode> },
//   ];

//   return (
//     <div className='h-screen w-screen ' >

//       <Header></Header>





//       <div className="mx-10  flex flex-col justify-center items-center rounded-t-2xl mt-10 ">


//         <div
//           className="flex w-full flex-wrap max-w-8xl bg-transparent p-3 sm:p-4 md:p-6 gap-2 sm:gap-4 md:gap-6 lg:gap-10 
//   rounded-t-2xl overflow-hidden backdrop-blur-3xl shadow-[0_0_10px_rgba(0,0,0,0.2)] "
//         >
//           {tabs.map((tab) => (
//             <button
//               key={tab.id}
//               onClick={() => setActiveTab(tab.id)}
//               className={`flex lg:flex-1 sm:flex-grow-0 w-full items-center justify-center gap-1 sm:gap-2 
//       rounded-md py-3 sm:py-3 md:py-4 px-2 sm:px-3 md:px-4 
//       text-[10px] sm:text-xs md:text-sm lg:text-lg font-medium transition-colors 
//       shadow-[0_0_10px_rgba(0,0,0,0.2)]
//       ${activeTab === tab.id
//                   ? "bg-black/20 border-b-2 border-black/80 text-black"
//                   : "bg-black text-black hover:bg-gray-200"
//                 }`}
//             >
//               {tab.icon}
//               {tab.label}

//             </button>
//           ))}
//         </div>




//         <div className="
//          backdrop-blur-3xl shadow-[0_0_10px_rgba(0,0,0,0.2)]


//         bg-white
//        w-full max-w-8xl p-4 rounded-b-2xl ">
//           {activeTab === "ui" && (


//             <div className="process-content ">


//               <div className="process-container">





//                 <div className="process-step">
//                   <div className="image-box">
//                     <img src="order.png" alt="Order-Setting-Image" />
//                   </div>
//                   <div className="content-box">


//                     <div className="content-item">
//                       <span className="label">→ A</span>
//                       <p>a. Exchange – Select the trading exchange (e.g., NSE, BSE).</p>
//                     </div>

//                     <div className="content-item">
//                       <span className="label">→ A</span>
//                       <p>b. Contract Type – Choose the type of contract (e.g., Equity, Futures, Options).</p>
//                     </div>

//                     <div className="content-item">
//                       <span className="label">→ A</span>
//                       <p>c. Symbol – Enter the trading symbol (e.g., JINDAL SAW).</p>
//                     </div>

//                     {/* <!-- B: Order Settings --> */}
//                     <div className="content-item">
//                       <span className="label">→ B</span>
//                       <p>(1.a) Entry Order Type – Define the type of order (e.g., Market, Limit).</p>
//                     </div>

//                     <div className="content-item">
//                       <span className="label">→ B</span>
//                       <p>(1.b) Action – Select the action to perform (Buy or Sell).</p>
//                     </div>

//                     <div className="content-item">
//                       <span className="label">→ B</span>
//                       <p>(2.a) Quantity Type – Choose between order types like Normal, Intraday.</p>
//                     </div>

//                     <div className="content-item">
//                       <span className="label">→ B</span>
//                       <p>(2.b) Quantity – Specify the number of units or shares.</p>
//                     </div>

//                     <div className="content-item">
//                       <span className="label">→ B</span>
//                       <p>(3.a) Expire in Seconds – Time in seconds before the order expires.</p>
//                     </div>

//                     <div className="content-item">
//                       <span className="label">→ B</span>
//                       <p>(3.b) If Touch Price – Trigger price at which the order is executed.</p>
//                     </div>

//                   </div>
//                 </div>

//                 <div className="process-step">
//                   <div className="image-box">
//                     <img src="risk.png" alt="Risk-Setting-Image" />
//                   </div>
//                   <div className="content-box">



//                     <div className="content-item">
//                       <span className="label">→ C</span>
//                       <p>(1.a) SL Type – Select the method for calculating stop loss (e.g., By Points).</p>
//                     </div>

//                     <div className="content-item">
//                       <span className="label">→ C</span>
//                       <p>(1.b) SL Value – Set the numerical value for stop loss.</p>
//                     </div>

//                     <div className="content-item">
//                       <span className="label">→ C</span>
//                       <p>(1.c) SL If Touch Price – Specify the price that triggers stop loss.</p>
//                     </div>

//                     <div className="content-item">
//                       <span className="label">→ C</span>
//                       <p>(2.a) TP Type – Choose how take profit is calculated (e.g., By Points).</p>
//                     </div>

//                     <div className="content-item">
//                       <span className="label">→ C</span>
//                       <p>(2.b) TP Value – Set the value for taking profit.</p>
//                     </div>

//                   </div>
//                 </div>

//                 <div className="process-step">
//                   <div className="image-box">
//                     <img src="advance.png" alt="Advanced-Setting-Image" />
//                   </div>
//                   <div className="content-box">


//                     <div className="content-item">
//                       <span className="label">→ D</span>
//                       <p>(1.a) Breakeven Type – Select how breakeven is calculated (e.g., By Points).</p>
//                     </div>

//                     <div className="content-item">
//                       <span className="label">→ D</span>
//                       <p>(1.b) Breakeven Value – Enter the breakeven value trigger.</p>
//                     </div>

//                     <div className="content-item">
//                       <span className="label">→ D</span>
//                       <p>(2.a) SL Trail Type – Choose how the stop loss should trail the price.</p>
//                     </div>

//                     <div className="content-item">
//                       <span className="label">→ D</span>
//                       <p>(2.b) SL Trail Value – Set the trailing distance for stop loss.</p>
//                     </div>

//                     <div className="content-item">
//                       <span className="label">→ D</span>
//                       <p>(2.c) SL Price Move – Define the minimum price move to trigger SL trail adjustment.</p>
//                     </div>

//                     <div className="content-item">
//                       <span className="label">→ D</span>
//                       <p>(3.a) Duplicate Position – Enable to duplicate the current trade.</p>
//                     </div>

//                     <div className="content-item">
//                       <span className="label">→ D</span>
//                       <p>(3.b) Reverse Close – Automatically place a reverse trade when the current one closes.</p>
//                     </div>

//                   </div>
//                 </div>

//                 <div className="process-step">
//                   <div className="image-box">
//                     <img src="generatealert.png" alt="GenerateAlert-Image" />
//                   </div>
//                   <div className="content-box">
//                     <div className="content-item">
//                       <span className="label">→ A</span>
//                       <p>Normal – Triggers a basic trading alert with fixed input values for order placement.</p>
//                     </div>

//                     <div className="content-item">
//                       <span className="label">→ B</span>
//                       <p>Indicator – Executes trades based on indicator-based alerts such as RSI or Moving Averages.</p>
//                     </div>

//                     <div className="content-item">
//                       <span className="label">→ C</span>
//                       <p>Strategy – Uses advanced strategy logic to automate execution based on defined market conditions.</p>
//                     </div>


//                   </div>
//                 </div>

//                 <div className="process-step">
//                   <div className="image-box">
//                     <img src="/assets/dashboardimage.png" alt="Dashboard-Image" />




//                   </div>
//                   <div className="content-box">

//                     <div className="content-item">
//                       <span className="label">→ A</span>
//                       <p>Dashboard Header – Controls for toggling trading and navigating main sections:</p>
//                     </div>

//                     <div className="content-item">
//                       <span className="label">→ A.a</span>
//                       <p>Trading is ON – Indicates system status (active/inactive for auto trading).</p>
//                     </div>

//                     <div className="content-item">
//                       <span className="label">→ A.b</span>
//                       <p>Alert – Displays incoming signals or triggers configured in the system.</p>
//                     </div>

//                     <div className="content-item">
//                       <span className="label">→ A.c</span>
//                       <p>Order – Shows current and past trade orders placed.</p>
//                     </div>

//                     <div className="content-item">
//                       <span className="label">→ A.d</span>
//                       <p>Position – Summarizes open trades and positions held.</p>
//                     </div>

//                     <div className="content-item">
//                       <span className="label">→ B</span>
//                       <p>Data Filters – Controls to manage and search alert data.</p>
//                     </div>

//                     <div className="content-item">
//                       <span className="label">→ B.a</span>
//                       <p>Search Alert – Search bar to filter alerts by keyword or symbol.</p>
//                     </div>

//                     <div className="content-item">
//                       <span className="label">→ B.b</span>
//                       <p>Select Date – Choose a specific date to filter alert history.</p>
//                     </div>

//                     <div className="content-item">
//                       <span className="label">→ B.c</span>
//                       <p>Download Data – Exports alert records as downloadable files.</p>
//                     </div>

//                     <div className="content-item">
//                       <span className="label">→ B.d</span>
//                       <p>Refresh Data – Updates alert list to show latest changes.</p>
//                     </div>

//                     <div className="content-item">
//                       <span className="label">→ C</span>
//                       <p>Bottom Panel – Utilities for order action and support.</p>
//                     </div>

//                     <div className="content-item">
//                       <span className="label">→ C.a</span>
//                       <p>Buy or Sell – Manual trigger for placing a trade order.</p>
//                     </div>

//                     <div className="content-item">
//                       <span className="label">→ C.b</span>
//                       <p>Chat Box – Support chat widget for help or feedback.</p>
//                     </div>

//                     <div className="content-item">
//                       <span className="label">→ C.c</span>
//                       <p>Doc – Opens documentation or help guide in the interface.</p>
//                     </div>

//                   </div>

//                 </div>

//               </div> 
//             </div>
//           )}



//           {activeTab === "tradingview" && (
//             <div >
//               <div className="flex justify-center ">
//                 <div className="  w-full lg:w-[1300px] sm:h-64 border-2 border-gray-400 rounded-lg flex items-center justify-center text-gray-500 text-sm sm:text-base">

//                   <video
//                     className="w-full h-full rounded-lg"
//                     controls
//                     src="/assets/tradingvideo.mp4"
//                   ></video>

//                 </div>


//               </div>

//               {/* <h2 className="font-semibold text-gray-800 mb-2 text-lg">
//               Description
//             </h2>
//             <p className="text-gray-600 text-sm sm:text-base leading-relaxed">
//               Configure alerts in TradingView and connect them here using your
//               webhook.
//             </p> */}
//             </div>
//           )}

//           {activeTab === "code" && (
//             <div className='flex justify-center'>
//               <div className='  w-full lg:w-[1300px] max-w-[500px]'>
//                 {/* <h2 className="font-semibold text-gray-800 mb-4 text-lg">Step 2</h2> */}
//                 <pre className="bg-gray-900 text-green-400 p-4 rounded-lg overflow-x-auto text-xs sm:text-sm">
//                   {`import requests

// requests.post("webhook_url", data={"key": "value"})`}
//                 </pre>
//                 {/* <p className="mt-3 text-gray-600 text-sm sm:text-base leading-relaxed">
//               Use this Python snippet to send alerts programmatically via code.
//             </p> */}
//               </div>
//             </div>
//           )}
//         </div>
//       </div>

//       <Footer></Footer>
//     </div>

//     // </div>
//   );
// }

// export default ProcessOverview


import React, { useState } from 'react'
import Header from './Header'
import Footer from './Footer'

const ProcessOverview = () => {

  const [showMore, setShowMore] = useState(false);
  return (

    <div className='w-screen h-screen'>

      <Header></Header>

      <div className="w-full flex-col justify-center items-center p-4 ">
        <div className="w-full max-w-8xl my-4 bg-white/80 rounded-xl shadow-lg border border-gray-300 p-6 flex flex-col md:flex-row gap-6">

          {/* Left Side - Step Info */}
          <div className="flex-1">
            <h2 className="text-lg font-semibold text-gray-600">STEP 1</h2>
            <h1 className="text-2xl font-bold text-gray-900 mt-1">Contract Type Selection</h1>

            <p className="text-gray-700 mt-2">
              Select the <span className="font-mono text-blue-600">Exchange</span>,
              <span className="font-mono text-blue-600">Contract Type</span>, and
              <span className="font-mono text-blue-600">Symbol</span> from the options above.
              Then configure your <span className="font-mono text-blue-600">Order Settings</span>
              such as Entry Order Type, Action, Quantity, Expiry, and Touch Price.
            </p>
            {/* <button className="text-blue-600 underline text-sm mt-2">
              Can’t find your installer?
            </button> */}

            {/* Collapsible content */}
            <div className="mt-4">
              {showMore && (
                <div className="space-y-2 text-gray-700">
                  <div>
                    <span className="font-semibold">→ A</span> Exchange – Select the trading exchange (e.g., NSE, BSE).
                  </div>
                  <div>
                    <span className="font-semibold">→ A</span> Contract Type – Choose the type of contract (e.g., Equity, Futures, Options).
                  </div>
                  <div>
                    <span className="font-semibold">→ A</span> Symbol – Enter the trading symbol (e.g., JINDAL SAW).
                  </div>
                  <div>
                    <span className="font-semibold">→ B</span> Entry Order Type – Define the type of order (e.g., Market, Limit).
                  </div>
                  <div>
                    <span className="font-semibold">→ B</span> Action – Select Buy or Sell.
                  </div>
                  <div>
                    <span className="font-semibold">→ B</span> Quantity Type – Normal or Intraday.
                  </div>
                  <div>
                    <span className="font-semibold">→ B</span> Quantity – Specify number of units.
                  </div>
                  <div>
                    <span className="font-semibold">→ B</span> Expire in Seconds – Time before order expires.
                  </div>
                  <div>
                    <span className="font-semibold">→ B</span> If Touch Price – Trigger price for execution.
                  </div>
                </div>
              )}

              <button
                onClick={() => setShowMore(!showMore)}
                className="mt-3 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
              >
                {showMore ? "Show Less" : "Show More"}
              </button>
            </div>
          </div>

          {/* Right Side - Image */}
          <div className="flex-1 flex  shadow-2xl justify-center items-center bg-white rounded-2xl max-w-md p-2 border-3 border-black">
            <img
              src="order1.png"
              alt="Step 2"

              className="rounded-xl shadow-md w-full max-w-md object-contain border border-blue-600 "
            />
          </div>
        </div>

        <div className="w-full max-w-8xl bg-white/80 my-4 rounded-xl shadow-2xl border border-gray-300 p-6 flex flex-col md:flex-row gap-6">

          {/* Left Side - Step Info */}
          <div className="flex-1">
            <h2 className="text-lg font-semibold text-gray-600">STEP 2</h2>
            <h1 className="text-2xl font-bold text-gray-900 mt-1">Risk Setting</h1>

            <p className="text-gray-700 mt-2">
              Configure your <span className="font-mono text-blue-600">Risk Settings</span> by
              selecting the <span className="font-mono text-blue-600">TP Type</span> and entering
              the <span className="font-mono text-blue-600">TP Point Value</span>.
              Similarly, set the <span className="font-mono text-blue-600">SL Type</span>,
              <span className="font-mono text-blue-600">SL Point Value</span>, and
              <span className="font-mono text-blue-600">SL Touch Price</span> to define your stop loss levels.
            </p>
            {/* 
            <button className="text-blue-600 underline text-sm mt-2">
              Can’t find your installer?
            </button> */}

            {/* Collapsible content */}
            <div className="mt-4">
              {showMore && (
                <div className="space-y-2 text-gray-700">

                  <div>
                    <span className="font-semibold">→ A </span>   (1.a) TP Type – Choose how take profit is calculated (e.g., By Points)
                  </div>

                  <div>
                    <span className="font-semibold">→ A</span>    (1.b) TP Value – Set the value for taking profit.
                  </div>

                  <div>
                    <span className="font-semibold">→ B </span>   (2.a) SL Type – Select the method for calculating stop loss (e.g., By Points).
                  </div>
                  <div>
                    <span className="font-semibold">→ B</span>    (2.b) SL Value – Set the numerical value for stop loss..
                  </div>
                  <div>
                    <span className="font-semibold">→ B</span>    (2.c) SL Touch Price – Specify the price that triggers stop loss..
                  </div>





                </div>
              )}

              <button
                onClick={() => setShowMore(!showMore)}
                className="mt-3 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
              >
                {showMore ? "Show Less" : "Show More"}
              </button>
            </div>
          </div>

          {/* Right Side - Image */}
          <div className="flex-1 flex  shadow-2xl justify-center items-center bg-white rounded-2xl max-w-md p-2 border-3 border-black">
            <img
              src="risk1.png"
              alt="Step 1"

              className="rounded-xl shadow-md w-full max-w-md object-contain border border-blue-600  "
            />
          </div>
        </div>

        <div className="w-full max-w-8xl bg-white/80  my-4 rounded-xl shadow-2xl border border-gray-300 p-6 flex flex-col md:flex-row gap-6">

          {/* Left Side - Step Info */}
          <div className="flex-1">
            <h2 className="text-lg font-semibold text-gray-600">STEP 3</h2>
            <h1 className="text-2xl font-bold text-gray-900 mt-1">Advanced Setting</h1>

            <p className="text-gray-700 mt-2">
              Set <span className="font-mono text-blue-600">Breakeven Type</span> and
              <span className="font-mono text-blue-600">Point Value</span>.
              Configure <span className="font-mono text-blue-600">SL Trail Type</span>,
              <span className="font-mono text-blue-600">Trail %</span>, and
              <span className="font-mono text-blue-600">SL Price Move</span>.
              Use <span className="font-mono text-blue-600">Duplicate Position</span> or
              <span className="font-mono text-blue-600">Existing Close</span> if needed.
            </p>

            {/* <button className="text-blue-600 underline text-sm mt-2">
              Can’t find your installer?
            </button> */}


            {/* Collapsible content */}
            <div className="mt-4">
              {showMore && (
                <div className="space-y-2 text-gray-700">
                  <div>
                    <span className="font-semibold">→ A </span> (1.a) Breakeven Type – Select how breakeven is calculated (e.g., By Points).
                  </div>
                  <div>
                    <span className="font-semibold">→ A </span> (1.b) Breakeven Value – Enter the breakeven value trigger..
                  </div>
                  <div>
                    <span className="font-semibold">→ B </span> (2.a) SL Trail Type – Choose how the stop loss should trail the price.
                  </div>
                  <div>
                    <span className="font-semibold">→ B </span> (2.b) SL Trail Value – Set the trailing distance for stop loss.
                  </div>
                  <div>
                    <span className="font-semibold">→ B</span> (2.c) SL Price Move – Define the minimum price move to trigger SL trail adjustment..
                  </div>
                  <div>
                    <span className="font-semibold">→ C </span> (3.a) Duplicate Position – Enable to duplicate the current trade.
                  </div>
                  <div>
                    <span className="font-semibold">→ C </span> (3.b) Reverse Close – Automatically place a reverse trade when the current one closes.
                  </div>


                </div>
              )}

              <button
                onClick={() => setShowMore(!showMore)}
                className="mt-3 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
              >
                {showMore ? "Show Less" : "Show More"}
              </button>
            </div>
          </div>

          {/* Right Side - Image */}
          <div className="flex-1 flex  shadow-2xl justify-center items-center bg-white rounded-2xl max-w-md p-2 border-3 border-black ">
            <img
              src="advance1.png"
              alt="Step 1"

              className="rounded-xl shadow-md w-full max-w-md object-contain border border-blue-600 "
            />
          </div>
        </div>

        <div className="w-full max-w-8xl bg-white/80   my-4 rounded-xl shadow-2xl border border-gray-300 p-6 flex flex-col md:flex-row gap-6">

          {/* Left Side - Step Info */}
          <div className="flex-1">
            <h2 className="text-lg font-semibold text-gray-600">STEP 4</h2>
            <h1 className="text-2xl font-bold text-gray-900 mt-1">Generate Alert</h1>


            <p className="text-gray-700 mt-2">
              Choose the <span className="font-mono text-blue-600">Alert Type</span> —
              <span className="font-mono text-blue-600">Normal</span>,
              <span className="font-mono text-blue-600">Indicator</span>, or
              <span className="font-mono text-blue-600">Strategy</span> —
              based on your requirement.
            </p>

            {/* <button className="text-blue-600 underline text-sm mt-2">
              Can’t find your installer?
            </button> */}



            {/* Collapsible content */}
            <div className="mt-4">
              {showMore && (
                <div className="space-y-2 text-gray-700">
                  <div>
                    <span className="font-semibold">→ A </span> Normal – Triggers a basic trading alert with fixed input values for order placement.
                  </div>
                  <div>
                    <span className="font-semibold">→ B </span>Indicator – Executes trades based on indicator-based alerts such as RSI or Moving Averages.
                  </div>
                  <div>
                    <span className="font-semibold">→ C </span> Strategy – Uses advanced strategy logic to automate execution based on defined market conditions.
                  </div>

                </div>
              )}

              <button
                onClick={() => setShowMore(!showMore)}
                className="mt-3 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
              >
                {showMore ? "Show Less" : "Show More"}
              </button>
            </div>
          </div>



          {/* Right Side - Image */}
          <div className="flex-1 flex  shadow-2xl justify-center items-center bg-white rounded-2xl max-w-md p-2 border-3 border-black  ">
            <img
              src="generatealert.png"
              alt="Step 1"

              className="rounded-xl shadow-md w-full max-w-md object-contain border border-blue-600 "
            />
          </div>
        </div>

        <div className="w-full max-w-8xl bg-white/80  my-4 rounded-xl shadow-2xl border border-gray-300 p-6 flex flex-col md:flex-row gap-6">

          {/* Left Side - Step Info */}
          <div className="flex-1">
            <h2 className="text-lg font-semibold text-gray-600">STEP 5</h2>
            <h1 className="text-2xl font-bold text-gray-900 mt-1">See Dashboard</h1>


            <p className="text-gray-700 mt-2">
              On the <span className="font-mono text-blue-600">Dashboard</span>, navigate through the main tabs:
              <span className="font-mono text-blue-600">Alert</span>,
              <span className="font-mono text-blue-600">Order</span>, and
              <span className="font-mono text-blue-600">Position</span> to manage your trades effectively.
            </p>

            {/* <button className="text-blue-600 underline text-sm mt-2">
              Can’t find your installer?
            </button> */}

            {/* Collapsible content */}
            <div className="mt-4">
              {showMore && (
                <div className="space-y-2 text-gray-700">
                  <div>
                    <span className="font-semibold">→ A</span> Dashboard Header – Controls for toggling trading and navigating main sections:
                  </div>
                  <div>
                    <span className="font-semibold">→ B</span> Trading is ON – Indicates system status (active/inactive for auto trading)
                  </div>
                  <div>
                    <span className="font-semibold">→ C</span> Alert – Displays incoming signals or triggers configured in the system.
                  </div>
                  <div>
                    <span className="font-semibold">→ D</span> Select Date – Choose a specific date to filter alert history..
                  </div>
                  <div>
                    <span className="font-semibold">→ E</span> Position – Summarizes open trades and positions held..
                  </div>
                  <div>
                    <span className="font-semibold">→ F</span>Order – Shows current and past trade orders placed.
                  </div>
                  <div>
                    <span className="font-semibold">→ G</span> Data Filters – Controls to manage and search alert data
                  </div>
                  <div>
                    <span className="font-semibold">→ H</span> Select Date – Choose a specific date to filter alert history.
                  </div>
                  <div>
                    <span className="font-semibold">→ I</span> Download Data – Exports alert records as downloadable files.
                  </div>

                  <div>
                    <span className="font-semibold">→ J</span> Refresh Data – Updates alert list to show latest changes.
                  </div>

                  <div>
                    <span className="font-semibold">→ K</span> Bottom Panel – Utilities for order action and support.
                  </div>

                  <div>
                    <span className="font-semibold">→ L</span> Buy or Sell – Manual trigger for placing a trade order.
                  </div>

                  <div>
                    <span className="font-semibold">→ M</span> Chat Box – Support chat widget for help or feedback.
                  </div>



                  <div>
                    <span className="font-semibold">→ N</span>  Doc – Opens documentation or help guide in the interface.
                  </div>
                </div>
              )}

              <button
                onClick={() => setShowMore(!showMore)}
                className="mt-3 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
              >
                {showMore ? "Show Less" : "Show More"}
              </button>
            </div>
          </div>

          {/* Right Side - Image */}
          <div className="flex-1 flex  shadow-2xl justify-center items-center bg-white rounded-2xl max-w-md p-2 border-3 border-black  ">
            <img
              src="dashboard1.png"
              alt="Step 1"

              className="rounded-xl shadow-md w-full max-w-md object-contain border border-blue-600  "
            />
          </div>
        </div>
      </div>

      <Footer></Footer>

    </div>

  )
}

export default ProcessOverview